import React, { useState, useEffect, useRef } from "react";
import { BottomNavigationMobileWrapper } from "./components/BottomBarNavigationWrapper";
import HomeBottomBarNavigationItem from "./components/HomeBottomBarNavigationItem";
import InPlayBottomBarNavigationItem from "./components/InPlayBottomBarNavigationItem";
import CasinoBottomBarNavigationItem from "./components/CasinoBottomBarNavigationItem";
import MyBetsBottomBarNavigationItem from "./components/MyBetsBottomBarNavigationItem";
import LinkBottomBarNavigationItem from "./components/LinkBottomBarNavigationItem";
import AZSportsBottomBarNavigationItem from "./components/AZSportsBottomBarNavigationItem";
import { PageContextUtils } from "../../utils";
import { CSSVarNames } from "../../constants";

const BottomBarNavigation = () => {
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);
  const timeoutId = useRef(null);
  const { bottomBarNavigationComponents } = PageContextUtils.getVisualData();

  useEffect(() => {
    lastScrollY.current = window.scrollY;
    const handleScroll = () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY.current) {
        setIsVisible(false);
        document.body.style.setProperty(
          CSSVarNames.BottomNavbarMobileGap,
          "0rem"
        );
      } else if (currentScrollY < lastScrollY.current) {
        setIsVisible(true);
        document.body.style.setProperty(
          CSSVarNames.BottomNavbarMobileGap,
          "7.6rem"
        );
      }

      lastScrollY.current = currentScrollY;

      timeoutId.current = setTimeout(() => {
        setIsVisible(true);
        document.body.style.setProperty(
          CSSVarNames.BottomNavbarMobileGap,
          "7.6rem"
        );
      }, 600);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
    };
  }, []);

  return (
    <BottomNavigationMobileWrapper
      isVisible={isVisible}
      data-testid={"uc-bottom-navigation-bar"}
    >
      {bottomBarNavigationComponents.map((comp, index) => {
        const components = {
          HOME: <HomeBottomBarNavigationItem key={index} />,
          INPLAY: <InPlayBottomBarNavigationItem key={index} />,
          MY_BETS: <MyBetsBottomBarNavigationItem key={index} />,
          LINK: (
            <LinkBottomBarNavigationItem
              key={index}
              href={comp.href}
              gaLabel={comp.gaLabel}
              iconLabel={comp.iconLabel}
              dataTestId={comp.dataTestId}
            />
          ),
          CASINO: <CasinoBottomBarNavigationItem key={index} />,
          AZ_SPORTS: <AZSportsBottomBarNavigationItem key={index} />
        };
        return components[comp.id] || null;
      })}
    </BottomNavigationMobileWrapper>
  );
};

export default React.memo(BottomBarNavigation);
